import React, { useLayoutEffect, useState } from 'react';

import { EVENTS } from '../../utilities/CONSTANTS';
import {
    getContentSuggestionsUrl,
    getTeamUrl,
    getKaiDashboardUrl,
    getQuestionsUrl,
    isDashboardUrl,
    isKaiDashboardUrl,
    isQuestionsUrl,
    isContentSuggestionsUrl,
    getUserProfileUrl,
    isUserProfileUrl,
} from '../../utilities/urlHelper';
import {
    canViewTeam,
    canViewKaiDashboard,
    canViewSetupGuide,
} from '../../utilities/permissionsUtilities';
import useUserTodoCount from '../../hooks/useUserTodoCount';
import SetupGuideSidebarLink from '../setup-guide/SetupGuideSidebarLink';
import { hasKaiFeature } from '../../utilities/featureHelper';

const TodoCount = ({ todoCount }) => {
    if (!canViewTeam()) return null;

    const [sidebarNumber, setSidebarNumber] = useState();

    const updateTodoCount = () => {
        setSidebarNumber(todoCount && todoCount > 0 ? todoCount : '');
    };

    useLayoutEffect(() => {
        updateTodoCount();
        window.addEventListener(EVENTS.UPDATE_SIDEBAR_NUMBER, updateTodoCount);
        return () => window.removeEventListener(EVENTS.UPDATE_SIDEBAR_NUMBER, updateTodoCount);
    }, [todoCount]);

    return <span id="sidebar-number" className="tab-nav-count right flex-none">{sidebarNumber}</span>;
};

const TeamHomeLink = () => (
    <a href={getTeamUrl()} className={`left-nav__item left-nav__static-link ${isDashboardUrl() ? 'left-nav__selected' : ''}`}>
        <img className="left-nav__icon" height="22" width="22" style={{ backgroundColor: '#02B8D4' }} src="/img/icons/team-home-icon.svg" alt="" />
        <span className="left-nav__text">Team Home</span>
    </a>
);

const KaiDashboardLink = () => (
    <a href={getKaiDashboardUrl()} className={`left-nav__item left-nav__static-link ${isKaiDashboardUrl() ? 'left-nav__selected' : ''}`}>
        <img className="left-nav__icon" height="22" width="22" style={{ backgroundColor: '#d40264' }} src="/img/kai.png" alt="Kai Dashboard icon" />
        <span className="left-nav__text">Kai Dashboard</span>
    </a>
);

const UserProfileLink = ({ todoCount }) => (
    <a href={getUserProfileUrl(window.userId)} className={`left-nav__item left-nav__static-link ${isUserProfileUrl(window.userId) ? 'left-nav__selected' : ''}`}>
        <img className="left-nav__icon" height="22" width="22" style={{ backgroundColor: '#0AC247' }} src="/img/icons/drafts-todos-icon.svg" alt="" />
        <span className="left-nav__text">Drafts &amp; To-dos</span>
        <TodoCount todoCount={todoCount} />
    </a>
);

const QuestionsLink = ({ questionCount }) => (
    <a href={getQuestionsUrl()} className={`left-nav__item left-nav__static-link ${isQuestionsUrl() ? 'left-nav__selected' : ''}`}>
        <img className="left-nav__icon" height="22" width="22" style={{ backgroundColor: '#F62888' }} src="/img/icons/question-icon.svg" alt="questions icon" />
        <span className="flex-auto left-nav__text">Questions &amp; Answers</span>
        {canViewTeam() && <span className="tab-nav-count right flex-none">{questionCount > 0 ? questionCount : ''}</span> }
    </a>
);

const ContentSuggestions = () => (
    <a href={getContentSuggestionsUrl()} className={`left-nav__item left-nav__static-link ${isContentSuggestionsUrl() ? 'left-nav__selected' : ''}`}>
        <img className="left-nav__icon" height="22" width="22" style={{ backgroundColor: '#7E20E9' }} src="/img/icons/content-suggestions-icon.svg" alt="Knowlede management icon" />
        <span className="flex-auto left-nav__text">Knowledge Management</span>
        {canViewTeam() && <span id="sidebar-content-number" /> }
    </a>
);

const SidebarLinks = (props) => {
    const { todoCount, questionCount } = useUserTodoCount();

    return (
        <div className="flex-none px2">
            <TeamHomeLink />
            {canViewKaiDashboard() && <KaiDashboardLink />}
            {canViewTeam() && <UserProfileLink todoCount={todoCount} />}
            {canViewTeam() && <QuestionsLink questionCount={questionCount} />}
            {canViewTeam() && <ContentSuggestions />}
            {canViewSetupGuide() && <SetupGuideSidebarLink />}
        </div>
    );
};

export default SidebarLinks;
